import { createPinia, defineStore } from 'pinia';

export function createAppStore() {
	return createPinia();
}

export const useMainStore = defineStore({
	id: 'main',
	state: () => ({
		route: {},
		pagedata: {
			meta: {
				is_external_searchable: false,
				meta_description: 'Scott  Johnson, Dentist/Oral Surgeon Doctor in Ankeny, IA',
				meta_keywords: '',
				og_tags: [],
				page_title: 'Scott  Johnson, Dentist/Oral Surgeon Doctor in Ankeny, IA',
			},
			omniture: {
				s_topic: '1728',
				s_business_reference: 'Nav - Home Page',
				s_publication_source: 'webmd',
				s_sponsor_brand: '',
				s_sponsor_program: '',
				s_package_type: 'homepage',
				s_package_name: 'Home Page',
				s_channel_super_portal: '',
				s_channel_health: '',
				s_channel_topic_miniguide_guide: '',
				s_channel_mini: '',
				s_channel_micro: '',
				s_tug: '',
				s_topic_dir: '',
				s_mrt: '',
				s_site: 'core',
				s_assetname: '',
				s_searchterm: '',
				image_server_url: 'https://img.webmd.com/dtmcms/live',
				s_sensitive: 'false',
				s_mblv: 'false',
				s_tagemax: '',
				s_tagemin: '',
				s_cuih: '',
				s_cuil: '',
				s_cuim: '',
				s_sbtyp: '',
				s_tgender: '',
				s_furl: '/',
				s_uk_user: 'false',
				s_account: 'webmddev',
				s_server_type: '1b',
				s_server: 'WFAWS25L-CON-07',
				s_object_type: 'wbmd_pb_page',
				s_page_number: '',
				s_site_class: 'ooc',
				s_sponsored_uri: 'default.htm',
				s_pagename: 'www.webmd.com/default.htm',
				s_channel: '',
				s_intended_demographics: '__',
				s_stage_condition: '',
				s_asset_id: '091e9c5e816558a8',
				s_unique_id: '091e9c5e816558a8',
				s_company: 'webmd',
				s_refpath: '',
				s_pbnm: '',
				s_pbtp: '',
				s_tpcot: '',
			},
		},
	}),
	getters: {
		// ...getters
	},
	actions: {
		// ...actions
	},
});
